export const comments_5588475 = {"data":{"data":[],"links":{}}}